export function get(obj, path) {
    for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
        if (!obj) {
            return null;
        }
        obj = obj[path[i]];
    }
    return obj;
}
;
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ionic-native/dist/esm/util.js
// module id = 634
// module chunks = 0